import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import DataTable from '../../../components/data-table/DataTable'
import BasicCard from "../../../components/basics/cards/BasicCard";
import { ScenarioAPIService } from "../../../services/apis/ScenarioAPIService";

export default function DownloadScenarios({ scenarioSelection, filterArray }) {
    const [validationError, setValidationError] = useState('');
    const periodId = filterArray ? filterArray[0]['value'] : 0;
    const nodeId = filterArray ? filterArray[1]['value'] : 0;
    const currencyId = filterArray ? filterArray[2]['value'] : 0;
    const [selectedDownloadItems, setSelectedDownloadItems] = useState([])
    const [hasDownload, setHasDownload] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
   
    // set the variables for download item and checkboxes
    const [downloadOptions, setDownloadOptions] = useState({ hasDownload: true })

    const tableConfig = {
        tableData: scenarioSelection,
        tableColumns: ['Name', 'Scenario type', 'Percentage type', 'Memo'],
        tableColumnIds: ['scenarioName', 'scenarioType', 'percentageType', 'memo'],
        handleRowClick: (id) => {
            var i = id + 1;
        }
    }    

    useEffect(() => {
        setDownloadOptions({ hasDownload: true, selectedDownloadItems: selectedDownloadItems, setSelectedDownloadItems: setSelectedDownloadItems })
        if (scenarioSelection == 0) {
            setIsLoading(false);
        }
    }, [hasDownload, selectedDownloadItems])

    const downloadSelectedScenarios = () => {

        setValidationError('');

        if (nodeId === 0) {
            setValidationError('Please choose entity and group.');
            return;
        }

        let scenarioIds = [];
        for (let item = 0; item < selectedDownloadItems.length; item++) {
            scenarioIds.push(selectedDownloadItems[item]['scenarioID']);
        }

        if (scenarioIds.length === 0) {
            setValidationError('Please choose at least one item to download scenarios.');
            return;
        }

        let downloadScenarioDto = {
            PeriodId: periodId,
            NodeId: nodeId,
            CurrenctyId: currencyId,
            ScenarioIds: scenarioIds,
        };

        ScenarioAPIService.downloadScenarios(downloadScenarioDto).then(
            response => {
                setIsLoading(false);
                if (response == 0)
                    setValidationError(process.env.REACT_APP_USER_ERROR_MESSAGE);
                else {                    
                    // Create a URL for the blob
                    const url = URL.createObjectURL(response);

                    // Create a link element and set its href attribute to the blob URL
                    const link = document.createElement('a');
                    link.href = url;

                    // Set the link element's download attribute to the desired file name
                    link.download = 'ScenarioTemplate.xlsx';

                    // Click the link to download the file
                    link.click();

                    // Clean up the URL and link elements
                    URL.revokeObjectURL(url);
                    link.remove();
                }
            }
        );
    }

    return (
        <Container fluid className='basic-listing-container'>
            <Row>
                <Col>
                    <BasicCard cardConfig={{ cardTitle: '', cardHeadingElement: 'h4' }}>
                        {isLoading ? <p>Loading data ...</p> : ""}
                        {validationError ?
                            <p style={{ color: 'red' }}>{validationError}</p> : ""
                        }
                        {
                            scenarioSelection?.length > 0 ?
                                <>
                                    <div className='listing-table-wrapper'>
                                        <DataTable downloadOptions={downloadOptions} tableConfig={tableConfig} />
                                    </div>
                                    <span className='brd-download-items'>
                                        <span>
                                            <p>&nbsp;</p>
                                        </span>
                                        <Button variant='primary' onClick={downloadSelectedScenarios} >
                                            Download scenario(s)
                                        </Button>
                                    </span>
                                </>
                                : ""
                        }
                    </BasicCard>
                </Col>
            </Row>
        </Container>
    )
}